/**
 * This document contains the code to update the image based on the attribute selected.
 * This process will be chnages, it is here for reference.
 *
 * Product Variant (Attribute) Gallery.  This also adjusts the attribute selected on the list.
 * @param images
 */

const AttributeListSelector =
  "#ctl00_ContentPlaceHolder1_CAttributeControl1_DlAttributes_ctl00_AttributeName";

interface ImageInfo {
  Description: string;
  ImageSrc: string;
  ImageAlt: string;
  SelectIndex: number;
}

/**
 * Product Variant (Attribute) Gallery.  This also adjusts the attribute selected on the list.
 * @param images
 */
export const setupProductGallery = (images: ImageInfo[]) => {
  const val = document.querySelector(
    AttributeListSelector
  ) as HTMLSelectElement;
  const imageContainer = document.querySelector(
      ".img-container"
    ) as HTMLDivElement,
    productImage = document.querySelector("#product-img") as HTMLImageElement,
    gallery = document.createElement("section");
  gallery.setAttribute(
    "style",
    "display: flex; justify-content: space-between; max-width: 440px;"
  );

  function createImage(imageInfo: ImageInfo) {
    const div = document.createElement("div");
    const p = document.createElement("p");
    div.appendChild(p);

    const img = document.createElement("img");
    img.style.maxWidth = "100px";
    img.style.cursor = "pointer";
    div.appendChild(img);

    p.innerText = imageInfo.Description;
    img.src = imageInfo.ImageSrc;
    img.alt = imageInfo.ImageAlt;

    return div;
  }

  images.forEach((img) => {
    const el = createImage(img);

    el.addEventListener("click", () => {
      val.selectedIndex = img.SelectIndex;
      productImage.src = img.ImageSrc;
    });

    gallery.appendChild(el);
  });

  imageContainer?.insertAdjacentElement("beforeend", gallery);

  val?.addEventListener("change", function () {
    const img = images.find((e) => {
      return e.SelectIndex === this.selectedIndex;
    });

    if (img) {
      productImage.src = img.ImageSrc;
    }
  });
};
